// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/store_payment/v1/store_payment.proto (package fingertip.creator.store_payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Int32Value, proto3, Timestamp } from "@bufbuild/protobuf";
import { StorePayment } from "../../../common/type/v1/store_payment_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { StoreOrder } from "../../../common/type/v1/store_order_pb.js";
import { StoreInvoice } from "../../../common/type/v1/store_invoice_pb.js";

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripePaymentIntentPublicRequest
 */
export const CreateStripePaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripePaymentIntentPublicRequest",
  () => [
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripePaymentIntentPublicResponse
 */
export const CreateStripePaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripePaymentIntentPublicResponse",
  () => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripePaymentIntentPublicRequest
 */
export const UpdateStripePaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripePaymentIntentPublicRequest",
  () => [
    { no: 1, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripePaymentIntentPublicResponse
 */
export const UpdateStripePaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripePaymentIntentPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CancelStripePaymentIntentPublicRequest
 */
export const CancelStripePaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CancelStripePaymentIntentPublicRequest",
  () => [
    { no: 1, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CancelStripePaymentIntentPublicResponse
 */
export const CancelStripePaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CancelStripePaymentIntentPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeInvoicePaymentIntentPublicRequest
 */
export const CreateStripeInvoicePaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeInvoicePaymentIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeInvoicePaymentIntentPublicResponse
 */
export const CreateStripeInvoicePaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeInvoicePaymentIntentPublicResponse",
  () => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeBookingPaymentIntentPublicRequest
 */
export const CreateStripeBookingPaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeBookingPaymentIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 6, name: "agreed_start_time", kind: "message", T: Timestamp },
    { no: 7, name: "custom_length", kind: "message", T: Int32Value },
    { no: 8, name: "custom_price", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeBookingPaymentIntentPublicResponse
 */
export const CreateStripeBookingPaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeBookingPaymentIntentPublicResponse",
  () => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeBookingSetupIntentPublicRequest
 */
export const CreateStripeBookingSetupIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeBookingSetupIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "agreed_start_time", kind: "message", T: Timestamp },
    { no: 5, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 7, name: "custom_length", kind: "message", T: Int32Value },
    { no: 8, name: "custom_price", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeBookingSetupIntentPublicResponse
 */
export const CreateStripeBookingSetupIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeBookingSetupIntentPublicResponse",
  () => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "setup_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripeBookingPaymentIntentPublicRequest
 */
export const UpdateStripeBookingPaymentIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripeBookingPaymentIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripeBookingPaymentIntentPublicResponse
 */
export const UpdateStripeBookingPaymentIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripeBookingPaymentIntentPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripeBookingSetupIntentPublicRequest
 */
export const UpdateStripeBookingSetupIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripeBookingSetupIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "setup_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.UpdateStripeBookingSetupIntentPublicResponse
 */
export const UpdateStripeBookingSetupIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.UpdateStripeBookingSetupIntentPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeSetupIntentPublicRequest
 */
export const CreateStripeSetupIntentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeSetupIntentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateStripeSetupIntentPublicResponse
 */
export const CreateStripeSetupIntentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateStripeSetupIntentPublicResponse",
  () => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "setup_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStripeBookingPaymentAmountPublicRequest
 */
export const GetStripeBookingPaymentAmountPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStripeBookingPaymentAmountPublicRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "custom_price", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStripeBookingPaymentAmountPublicResponse
 */
export const GetStripeBookingPaymentAmountPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStripeBookingPaymentAmountPublicResponse",
  () => [
    { no: 1, name: "total_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "deposit_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "discount_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "subtotal_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * To Deprecate
 *
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentComputationPublicRequest
 */
export const GetStorePaymentComputationPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentComputationPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "online_payment", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * To Deprecate
 *
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentComputationPublicResponse
 */
export const GetStorePaymentComputationPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentComputationPublicResponse",
  () => [
    { no: 1, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "application_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "payment_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "charge_total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "tax_total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "minimum_charge_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetPaymentComputationPublicRequest
 */
export const GetPaymentComputationPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetPaymentComputationPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "online_payment", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.PaymentComputationItem
 */
export const PaymentComputationItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.PaymentComputationItem",
  () => [
    { no: 1, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "application_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "payment_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "charge_total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "tax_total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "minimum_charge_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetPaymentComputationPublicResponse
 */
export const GetPaymentComputationPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetPaymentComputationPublicResponse",
  () => [
    { no: 1, name: "total", kind: "message", T: PaymentComputationItem },
    { no: 2, name: "deposit", kind: "message", T: PaymentComputationItem },
    { no: 3, name: "remaining", kind: "message", T: PaymentComputationItem },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.PaymentTransactionItem
 */
export const PaymentTransactionItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.PaymentTransactionItem",
  () => [
    { no: 1, name: "payment", kind: "message", T: StorePayment },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "refunds", kind: "message", T: StorePayment, repeated: true },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentsRequest
 */
export const GetStorePaymentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentsResponse
 */
export const GetStorePaymentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: PaymentTransactionItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentPublicRequest
 */
export const GetStorePaymentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.GetStorePaymentPublicResponse
 */
export const GetStorePaymentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.GetStorePaymentPublicResponse",
  () => [
    { no: 1, name: "payment", kind: "message", T: StorePayment },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "order", kind: "message", T: StoreOrder },
    { no: 7, name: "invoice", kind: "message", T: StoreInvoice },
    { no: 8, name: "refunds", kind: "message", T: StorePayment, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateIppsQrPaymentPublicRequest
 */
export const CreateIppsQrPaymentPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateIppsQrPaymentPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CreateIppsQrPaymentPublicResponse
 */
export const CreateIppsQrPaymentPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CreateIppsQrPaymentPublicResponse",
  () => [
    { no: 1, name: "qr_raw", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expired_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CheckIppsPaymentStatusPublicRequest
 */
export const CheckIppsPaymentStatusPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CheckIppsPaymentStatusPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_payment.v1.CheckIppsPaymentStatusPublicResponse
 */
export const CheckIppsPaymentStatusPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_payment.v1.CheckIppsPaymentStatusPublicResponse",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "transaction_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "transaction_sub_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

